module.exports = __webpack_public_path__ + "static/media/heaterIcon.b9b4deca.svg";